import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStakeholdersRoute: InvariantJiraRoute = {
	name: 'communications-stakeholders',
	path: '/jira/communications/stakeholders',
};
